module.exports = __webpack_public_path__ + "img/select.ad90f2f7.svg";